/**
 * Delegate function to given selector.
 * @param {string} selector
 * @param {function} fn
 * @returns {(function(*): void)|*}
 */
export const delegate = (selector, fn) => {
  return e => {
    if (!e.target.closest(selector)) {
      return
    }

    fn(e)
  }
}
